module.exports = __webpack_public_path__ + "img/logo.322c8a9e.png";